export default __webpack_public_path__ + "static/media/HatorHator.708d386e.mp3";